import { Component, OnDestroy, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import { TaskManagerConfig } from '../../helpers/task-manager.config';
import { select, Store } from '@ngrx/store';
import { TaskManagerState } from '../../store/task-manager.reducer';
import { TaskManagerQuery } from '../../helpers/task-manager.query';
import { GraphqlContentScope } from '@shared/models/graphql-content-scope.model';
import { getselectedBoard } from '../../store/task-manager.selector';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GetSelectedBoardAction } from '../../store/task-manager.action';
import { Configuration } from '@shared/models/configuration';
import { TaskManagerService } from '../../services/task-manager.service';

@Component({
    standalone: false,
    selector: 'particle-task-selector',
  templateUrl: './task-selector.component.html',
  styleUrls: ['./task-selector.component.scss']
})
export class TaskSelectorComponent implements OnInit, OnDestroy, IDialogView {

  data: DialogModel;
  breadcrumbs: BreadcrumbModel[];

  scope = 1;
  supportBoardScope = 3;
  supportBoardId = 'orbitax_support';

  invalidateSubjectBoardList: InvalidateSubject;
  invalidateSubjectTaskList: InvalidateSubject;
  private ngUnsubscribe = new Subject<void>();
  selectedBoard$: any;
  selectedBoard: any;

  sourceKey: string;
  sourceKeyTickets: string;
  boardId: string;
  isTaskVisible = false;
  selectedTask: any;
  selectedRow: any;
  taskManagerBoardListBreadCrumbModel = <BreadcrumbModel>{
    id: 'TaskManager',
    title: 'Task Manager',
    relativeUrl: '',
    type: 'BoardList'
  };

  constructor( protected taskManagerStore: Store<TaskManagerState>, protected taskManagerService: TaskManagerService) {
    this.breadcrumbs = [
      <BreadcrumbModel>this.taskManagerBoardListBreadCrumbModel
    ];
    this.invalidateSubjectBoardList = new InvalidateSubject();
    this.invalidateSubjectTaskList = new InvalidateSubject();
    this.sourceKey = 'BoardList';
    this.sourceKeyTickets = 'TaskSelectorTask';
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.selectedBoard$ = this.taskManagerStore.pipe(select(getselectedBoard));
    this.selectedBoard$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(selectedBoard => {
      if (!selectedBoard || selectedBoard.id !== this.boardId || !this.isTaskVisible) {
        return;
      }
      this.selectedBoard = selectedBoard;
      this.onLoadBoard(this.selectedBoard);
      const config = Configuration.getSmartGridConfig(this.sourceKeyTickets);
      config.Parameters['BOARD_ID'] = this.selectedBoard.id;
      config.Parameters['SCOPE'] = this.selectedBoard.scopeInt;
      this.invalidateSubjectTaskList.invalidate();
    });
  }
  onOkClicked() {
    this.data.input.selectedTask = this.selectedTask;
    return true;
  }
  onBreadcrumbSelectionChanged($event: BreadcrumbModel) {
    this.isTaskVisible = $event.type === 'TaskList';
    this.breadcrumbs = [
      <BreadcrumbModel>this.taskManagerBoardListBreadCrumbModel
    ];

  }
  onGridCellValueChange($event) {
    if ($event.fieldDefinition) {
      const item = $event.item;
      switch ($event.fieldDefinition.key) {
        case 'Title':
          this.openBoard(item);
          break;
      }
    }
  }

  private openBoard(item: any) {
    switch (item.cells.Type.value) {
      case 'OrbitaxSupport':
        this.loadBoard(this.supportBoardId, this.supportBoardScope);
        break;
      case 'Team':
      case 'Personal':
        this.loadBoard(item.id, this.scope);
        break;
    }
  }

  loadBoard(boardId: string, scope: number) {
    this.boardId = boardId;
    if (boardId) {
      this.isTaskVisible = true;
      this.taskManagerStore.dispatch(new GetSelectedBoardAction(TaskManagerConfig.TaskManagerApiKey,
        TaskManagerQuery.getSelectedBoard(boardId, GraphqlContentScope.getScope(scope))));
    }
  }

  protected onLoadBoard(selectedBoard) {
    this.breadcrumbs = [
      this.taskManagerBoardListBreadCrumbModel,
      <BreadcrumbModel>{
        id: 'board',
        title: selectedBoard.name,
        relativeUrl: '',
        type: 'TaskList'
      }
    ];
  }

  onSelectionChanged($event) {
    if(!this.data.input.canSelectAll && $event.selectedRows && $event.selectedRows.length > 1){
      $event.selectedRows.forEach(element => {
        element.dataItem.isChecked = false;
      });
      return;
    }
    this.selectedTask = $event.selectedRows && $event.selectedRows.length > 0 ?  $event.selectedRows[0].dataItem.cells.DueDate.value : null;
    if(!this.data.input.canSelectAll) {
      if($event.selectedRows && $event.selectedRows.length > 0) {
        if(this.selectedRow && this.selectedRow.index !== $event.selectedRows[0].index){
          this.selectedRow.dataItem.isChecked = false;
        }
        this.selectedRow = $event.selectedRows[0];
      }
    }
  }

  openAddTaskDialog() {
    this.taskManagerService.addTask('Task', this.selectedBoard, null, '800px', null, null, this.data.input.defaultName,  this.data.input.dueDate, undefined,  this.data.input.preventTaskAutoOpenAfterAdd);
  }
}
